import * as React from 'react';
import { Modal, Button } from "react-bootstrap";
import { connect } from 'react-redux';
import * as actionCreator from '../../actions/actions';
import { Dispatch } from 'redux';
import { Log } from "../../class/Log";
import Select from 'react-select';
import { MyLookup } from '../../class/Enums';
import moment from 'moment';
import { getUserAircraftLookupList, getUserAirportLookupList, getUserFavoritAircraftLookup, getUserFavoritAirportLookup } from './LogBookHelper';
import { UserAircraft } from '../../class/UserAircraft';
import { UserAirport } from '../../class/UserAirport';
import { LookupItem } from '../../class/LookupItem';
import { withOktaAuth } from '@okta/okta-react';

interface State {
    logBookId: any;
    logBookDate: any;
    logBookAircraftModel: any;
    logBookAircraftRegistration: any;
    logBookDeparturePlace: any;
    logBookDepartureTime: any;
    logBookArrivalPlace: any;
    logBookArrivalTime: any;
    logBookTotalFlightTime: any;
    logBookDescription: any;
    logBookIFR: any;
    logBookPIC: any;
    logBookNight: any;
    logBookDual: any;
    logBookCoPilot: any;
    logBookLanding: number;
    userAircrafLookuptList: Array<LookupItem>;
    userAirportLookuptList: Array<LookupItem>;
    userSelectedAicraft: LookupItem;
}

interface Props {
    popupTitle: string;
    log: Log;
    show: boolean;
    token: any;
    aircraftModelList: any;
    airportList: any;
    userAircraftList: Array<UserAircraft>;
    userAirportList: Array<UserAirport>;
    oktaAuth: any;
    authState: any;
    hide(): void;
    saveLog(token: any, p: Log): void;
    updateLog(token: any, p: Log): void;
    getLookupList(): any;
    getUserAircraftList(token: any): void;
    getUserAirportList(token: any): void;
}

class LogBookPopup extends React.Component<Props, State>{
    private socket: any;

    constructor(props: any) {
        super(props)
        this.state = {
            logBookId: 0,
            logBookDate: "",
            logBookAircraftModel: "",
            logBookAircraftRegistration: "",
            logBookDeparturePlace: "",
            logBookDepartureTime: "",
            logBookArrivalPlace: "",
            logBookArrivalTime: "",
            logBookTotalFlightTime: "",
            logBookDescription: "",
            logBookIFR: null,
            logBookPIC: null,
            logBookNight: null,
            logBookDual: null,
            logBookCoPilot: null,
            logBookLanding: 0,
            userAircrafLookuptList: [],
            userAirportLookuptList: [],
            userSelectedAicraft: { label: "asdasd", value: 1 }
        };
    }

    async componentDidMount() {
        while (!this.props.authState) {
            await new Promise(resolve => setTimeout(resolve, 100)); // Wait for 100 milliseconds
        }
        this.props.getLookupList();
        this.props.getUserAircraftList(this.props.authState.accessToken.accessToken);
        this.props.getUserAirportList(this.props.authState.accessToken.accessToken);

        this.setState({
            userAircrafLookuptList: getUserAircraftLookupList(this.props.userAircraftList),
            userAirportLookuptList: getUserAirportLookupList(this.props.userAirportList),
        })
    }

    componentDidUpdate(prevProps: any) {
        let aircraftLabel = this.props.log.userAircraft != undefined ? `${this.props.log.userAircraft.aircraftModel?.aircraftModelName || ''} | ${this.props.log.userAircraft.aircraftRegistration || ''}`
            : getUserFavoritAircraftLookup(this.props.userAircraftList).label;
        let aircraftValue = this.props.log.userAircraft != undefined ? this.props.log.userAircraft.userAircraftId
            : getUserFavoritAircraftLookup(this.props.userAircraftList).value;
        let airportDepartureLabel = this.props.log.airportDeparture != undefined ? this.props.log.airportDeparture.airportName + " | " + this.props.log.airportDeparture.airportCode
            : getUserFavoritAirportLookup(this.props.userAirportList).label;
        let airportArrivalLabel = this.props.log.airportArrival != undefined ? this.props.log.airportArrival.airportName + " | " + this.props.log.airportArrival.airportCode
            : getUserFavoritAirportLookup(this.props.userAirportList).label;
        let airportDepartureValue = this.props.log.airportDeparture != undefined ? this.props.log.airportDeparture.airportId
            : getUserFavoritAirportLookup(this.props.userAirportList).value;
        let airportArrivalValue = this.props.log.airportArrival != undefined ? this.props.log.airportArrival.airportId
            : getUserFavoritAirportLookup(this.props.userAirportList).value;

        //Edit Mode
        if (this.props !== prevProps) {
            this.setState({
                logBookId: this.props.log.logBookId,
                logBookDate: moment.parseZone(this.props.log.logBookDate).format('YYYY-MM-DD'),
                logBookAircraftModel: { label: aircraftLabel, value: aircraftValue },
                logBookDeparturePlace: { label: airportDepartureLabel, value: airportDepartureValue },
                logBookDepartureTime: this.props.log.logBookDepartureTime,
                logBookArrivalPlace: { label: airportArrivalLabel, value: airportArrivalValue },
                logBookArrivalTime: this.props.log.logBookArrivalTime,
                logBookTotalFlightTime: this.props.log.logBookTotalFlightTime,
                logBookDescription: this.props.log.logBookDescription,
                logBookIFR: this.props.log.logBookIFR != null ? this.props.log.logBookIFR : false,
                logBookPIC: this.props.log.logBookPIC != null ? this.props.log.logBookPIC : false,
                logBookCoPilot: this.props.log.logBookCoPilot != null ? this.props.log.logBookCoPilot : false,
                logBookDual: this.props.log.logBookDual != null ? this.props.log.logBookDual : false,
                logBookNight: this.props.log.logBookNight != null ? this.props.log.logBookNight : false,
                logBookLanding: this.props.log.logBookLanding != undefined ? this.props.log.logBookLanding : 0,
                userAircrafLookuptList: getUserAircraftLookupList(this.props.userAircraftList),
                userAirportLookuptList: getUserAirportLookupList(this.props.userAirportList),
            })
        }
    }

    handleChange = (e: any) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        this.setState({
            [e.target.id]: value
        } as any);
    }

    handleAircraftChange = (logBookAircraftModel: any) => {
        this.setState({ logBookAircraftModel : logBookAircraftModel });
    };

    handleAirportDepartureChange = (logBookDeparturePlace: any) => {
        this.setState({ logBookDeparturePlace });
    };

    handleAirportArrivalChange = (logBookArrivalPlace: any) => {
        this.setState({ logBookArrivalPlace });
    };

    handleDepartureChange = (e: any) => {
        this.setState({
            logBookDepartureTime: e.target.value,
        });
        if (this.state.logBookArrivalTime != undefined) {
            this.calculateFlightTime(e.target.value, this.state.logBookArrivalTime);
        }
    }

    handleArrivalChange = (e: any) => {
        this.setState({
            logBookArrivalTime: e.target.value,
        });
        if (this.state.logBookDepartureTime != undefined) {
            this.calculateFlightTime(this.state.logBookDepartureTime, e.target.value);
        }
    }

    /**
     * Calculates the flight time between two given times and updates the state with the result.
     *
     * @param {string} depart - Departure time in the format 'HH:MM'.
     * @param {string} arrival - Arrival time in the format 'HH:MM'.
     */
    calculateFlightTime = (depart: string, arrival: string) => {
        // Initialize total time and split departure and arrival times into hours and minutes
        let totalTime = 0;
        let startTime = depart.split(':') as any;
        let endTime = arrival.split(':') as any;
    
        // Calculate the total time in hour
        totalTime =  parseFloat((((endTime[0] * 60 + Number(endTime[1])) - (startTime[0] * 60 + Number(startTime[1])))/60).toFixed(2));
    
        // Update the component's state with the flight time in hours
        this.setState({
            logBookTotalFlightTime: totalTime,
        });
    }

    handleSaveLog = (e: any) => {
        e.preventDefault();
        var myLog: Log = ({

            logBookId: this.state.logBookId,
            logBookDate: this.state.logBookDate,
            airportDepartureId: this.state.logBookDeparturePlace.value,
            airportArrivalId: this.state.logBookArrivalPlace.value,
            logBookDepartureTime: this.state.logBookDepartureTime,
            logBookArrivalTime: this.state.logBookArrivalTime,
            logBookTotalFlightTime: this.state.logBookTotalFlightTime,
            logBookDescription: this.state.logBookDescription,
            logBookCoPilot: this.state.logBookCoPilot,
            logBookNight: this.state.logBookNight,
            logBookDual: this.state.logBookDual,
            logBookIFR: this.state.logBookIFR,
            logBookPIC: this.state.logBookPIC,
            logBookLanding: this.state.logBookLanding,
            userAircraftId: this.state.logBookAircraftModel.value,
            LogBookAircraftRegistration : this.state.logBookAircraftModel.label,
        });
        if (myLog.logBookId != undefined) {
           this.props.updateLog(this.props.token, myLog);
        }
        else {
           this.props.saveLog(this.props.token, myLog);
        }

        this.props.hide();
    }

    render() {

        return (
            <div>
                <Modal show={this.props.show} onHide={() => this.props.hide()}>
                    <Modal.Header style={{ backgroundColor: '#2c2c2c' }} closeButton>
                        <Modal.Title>{this.props.popupTitle}
                        </Modal.Title>
                    </Modal.Header >
                    <Modal.Body style={{ backgroundColor: '#2c2c2c' }} >

                        <form id="newUserForm" className="form-signin" onSubmit={this.handleSaveLog}>

                            <input id="logBookId" value={this.state.logBookId || ''} type="text" className="form-control" readOnly hidden></input>

                            <div className="row mb-2">
                                <div className="col-sm-2">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" checked={this.state.logBookIFR} id="logBookIFR" onChange={this.handleChange}></input>
                                        <label className="form-check-label" >IFR</label>
                                    </div>
                                </div>
                                <div className="col-sm-2">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" checked={this.state.logBookNight} id="logBookNight" onChange={this.handleChange}></input>
                                        <label className="form-check-label" >Night</label>
                                    </div>
                                </div>
                                <div className="col-sm-2">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" checked={this.state.logBookPIC} id="logBookPIC" onChange={this.handleChange}></input>
                                        <label className="form-check-label" >PIC</label>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" checked={this.state.logBookCoPilot} id="logBookCoPilot" onChange={this.handleChange}></input>
                                        <label className="form-check-label" >Co-Pilot</label>
                                    </div>
                                </div>
                                <div className="col-sm-2">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" checked={this.state.logBookDual} id="logBookDual" onChange={this.handleChange}></input>
                                        <label className="form-check-label" >Dual</label>
                                    </div>
                                </div>
                            </div>
                            <div className="mb-2 row">
                                <label className="col-sm-4 col-form-label">Date of flight</label>
                                <div className="col-sm-8">
                                    <input id="logBookDate" value={this.state.logBookDate} type="date" className="form-control" placeholder="Date" required onChange={this.handleChange}></input>
                                </div>
                            </div>

                            <div className="mb-2 row">
                                <label className="col-sm-4 col-form-label">Model / Reg.</label>
                                <div className="col-sm-8">
                                    <Select id="logBookAircraftModel" onChange={this.handleAircraftChange} options={this.state.userAircrafLookuptList} placeholder="Aircraft model" value={this.state.logBookAircraftModel}
                                        styles={{
                                            control: (baseStyles) => ({
                                                ...baseStyles,
                                                padding: '0px',
                                                minHeight: '32px', // Ensure minimum height to avoid clipping content
                                            }),
                                            option: (provided) => ({
                                                ...provided,
                                                color: 'black', // or any other color that provides good contrast
                                            }),
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="mb-2 row">
                                <label className="col-sm-4 col-form-label">From</label>
                                <div className="col-sm-8">
                                    <Select id="logBookDeparturePlace" onChange={this.handleAirportDepartureChange} options={this.props.airportList} placeholder="Airport departure" value={this.state.logBookDeparturePlace}
                                        styles={{
                                            control: (baseStyles) => ({
                                                ...baseStyles,
                                                padding: '0px',
                                                minHeight: '32px', // Ensure minimum height to avoid clipping content
                                            }),
                                            option: (provided) => ({
                                                ...provided,
                                                color: 'black', // or any other color that provides good contrast
                                            }),
                                            // Optionally, you can add more styling for other components like the menu, option, etc.
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="mb-2 row">
                                <label className="col-sm-4 col-form-label">Departure time</label>
                                <div className="col-sm-8">
                                    <input id="logBookDepartureTime" value={this.state.logBookDepartureTime || ''} type="time" className="form-control" placeholder="Date" required onChange={this.handleDepartureChange}></input>
                                </div>
                            </div>

                            <div className="mb-2 row">
                                <label className="col-sm-4 col-form-label">To</label>
                                <div className="col-sm-8">
                                    <Select id="logBookArrivalPlace" onChange={this.handleAirportArrivalChange} options={this.props.airportList} placeholder="Airport departure" value={this.state.logBookArrivalPlace}
                                        styles={{
                                            control: (baseStyles) => ({
                                                ...baseStyles,
                                                padding: '0px',
                                                minHeight: '32px', // Ensure minimum height to avoid clipping content
                                            }),
                                            option: (provided) => ({
                                                ...provided,
                                                color: 'black', // or any other color that provides good contrast
                                            }),
                                            // Optionally, you can add more styling for other components like the menu, option, etc.
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="mb-2 row">
                                <label className="col-sm-4 col-form-label">Arrival time</label>
                                <div className="col-sm-8">
                                    <input id="logBookArrivalTime" value={this.state.logBookArrivalTime || ''} type="time" className="form-control" placeholder="Date" required onChange={this.handleArrivalChange}></input>
                                </div>
                            </div>

                            <div className="mb-2 row">
                                <label className="col-sm-4 col-form-label">Total time flight</label>
                                <div className="col-sm-8">
                                    <input id="logBookTotalFlightTime" value={this.state.logBookTotalFlightTime || ''} type="text" className="form-control" placeholder="" required onChange={this.handleChange}></input>
                                </div>
                            </div>

                            <div className="mb-2 row">
                                <label className="col-sm-4 col-form-label">Landings</label>
                                <div className="col-sm-8">
                                    <input id="logBookLanding" value={this.state.logBookLanding || ''} type="text" className="form-control" placeholder="" required onChange={this.handleChange}></input>
                                </div>
                            </div>

                            <div className="mb-2 row">
                                <label className="col-sm-4 col-form-label">Note</label>
                                <div className="col-sm-8">
                                    <textarea id="logBookDescription" value={this.state.logBookDescription} rows={3} className="form-control" placeholder="" required onChange={this.handleChange}></textarea>
                                </div>
                            </div>

                        </form>
                    </Modal.Body>
                    <Modal.Footer style={{ backgroundColor: '#2c2c2c' }}>
                        <Button variant="secondary" onClick={() => this.props.hide()}>
                            Close
                        </Button>
                        <Button variant="success" type="submit" form="newUserForm" >
                            Save Changes
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

//map the props of this class to the root redux state
const mapStateToProps = (state: any) => {
    return {
        userId: state.userId,
        isDoorCodeValid: state.isNewDoorCodeValid,
        aircraftModelList: state.lookupList[MyLookup.AircraftList],
        airportList: state.lookupList[MyLookup.AirportList],
        userAircraftList: state.userAircraftList,
        userAirportList: state.userAirportList,
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        saveLog: (token: any, log: any) => dispatch<any>(actionCreator.default.logbook.addLog(token, log)),
        updateLog: (token: any, log: any) => dispatch<any>(actionCreator.default.logbook.updateLog(token, log)),
        getLookupList: () => dispatch<any>(actionCreator.default.lookup.getLookupList()),
        getUserAircraftList: (token: any) => dispatch<any>(actionCreator.default.userAircraft.getUserAircraftList(token)),
        getUserAirportList: (token: any) => dispatch<any>(actionCreator.default.userAirport.getUserAirportList(token)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withOktaAuth(LogBookPopup));